import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useQuery } from "@tanstack/react-query";
import RegistrationForm from "./RegistrationForm1";
import { fetchPatient } from "services/patient";
import Modal from "components/Common/Modal";
import { FILTER_DEFINATIONS, PACKAGE_COLUMNS_DATA } from "./config";
import usePagination from "hooks/usePagination";
import useFilterHook from "hooks/useFilter";
import { DEFAULT_TOTAL_RECORDS, MODALS, STALE_TIME } from "utils/constants";
import { useForm } from "react-hook-form";
import "./NewRegistration.scss";
import UploadDocument from "./UploadDocument";
import { useLocation } from "react-router-dom";
import Table from "components/Common/Table/index";
import RegistrationFormFormat from "./RegistrationFormat";
import { useSelector } from "react-redux";

const NewRegistration = () => {
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [zoneRegistrationData, setZoneRegistrationData] = useState({});
  const [documentModal, setDocumentModal] = useState(false);
  const [packageView, setPackageView] = useState(false);
  const [packageInvestigationData, setPackageInvestigationData] = useState([]);
  const [documentInfo, setdocumentInfo] = useState();
  const [isThirdPartyBarcode, setIsThirdPartyBarcode] = useState(false);
  const [shouldIncludeBarcodeFlag, setShouldIncludeBarcodeFlag] =
    useState(null);
  const [docmentAppointmentBookingId, setDocmentAppointmentBookingId] =
    useState(false);

  const search = useLocation().search;
  const appointment_id = new URLSearchParams(search).get("appointment_id");

  const [sampleTypeData, setSampleTypeData] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);

  const {
    formState: { errors },
    getValues,
  } = useForm();

  const { currentPage, updateCurrentPage, updateTotalRecords } =
    usePagination();

  const { filters } = useFilterHook(FILTER_DEFINATIONS, updateCurrentPage);

  const { refetch: refetchPatients } = useQuery(
    ["fetch-Patients", currentPage],
    () => fetchPatient(currentPage, filters),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      onSuccess: (res) => {
        updateTotalRecords(res.data.additional_data.total_count);
      },
      select: (res) => {
        const response = res?.data?.data;
        if (response && response.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => {
        console.error("Error fetching Patients:", res);
      },
    }
  );

  const handleDocuments = useCallback((data, e) => {
    setDocumentModal(true);
  }, []);

  const onClose = useCallback(
    (refetch = false) => {
      if (refetch) {
        refetchPatients();
      }
      setRowDataForEdit(null);
    },
    [refetchPatients]
  );

  const openPackageView = useCallback(
    (row, shouldIncludeBarcode) => {
      // const updatedRows = shouldIncludeBarcode
      //   ? row
      //   : row.map((item) => ({
      //       ...item,
      //       barcode_obj: {
      //         ...item.barcode_obj,
      //         barcode_no: null,
      //       },
      //     }));

      // console.log(
      //   "*********************updatedRows*********************",
      //   updatedRows
      // );

      if (!isThirdPartyBarcode) {
        setPackageInvestigationData(row);
      }

      setShouldIncludeBarcodeFlag(shouldIncludeBarcode);
      setPackageView(true);
    },
    [isThirdPartyBarcode]
  );

  const closePackageView = useCallback((refetch = false) => {
    setPackageView(false);
  }, []);

  const filterRef = useRef(filters);

  useEffect(() => {
    if (filterRef.current !== filters) {
      refetchPatients();
      filterRef.current = filters;
    }
  }, [filters, refetchPatients]);

  useEffect(() => {
    setZoneRegistrationData(getValues());
  }, [getValues]);

  const [barcodeDataState, setBarcodeDataState] = useState({});

  const handleBarcodeChange = useCallback((newValue, sampleType) => {
    setBarcodeData((prevBarcodes) => {
      const updatedBarcodes = [...prevBarcodes];
      const existingIndex = updatedBarcodes.findIndex(
        (item) => item.sample_type_id === sampleType.sample_type_id
      );

      if (existingIndex !== -1) {
        updatedBarcodes[existingIndex] = {
          ...updatedBarcodes[existingIndex],
          barcode_no: newValue,
          sample_type: sampleType,
        };
      } else {
        updatedBarcodes.push({
          barcode_no: newValue,
          sample_type: sampleType,
          sample_type_id: sampleType.sample_type_id,
        });
      }

      return updatedBarcodes;
    });

    setSampleTypeData((prevSampleTypes) => {
      const updatedSampleTypes = [...prevSampleTypes];
      const existingIndex = updatedSampleTypes.findIndex(
        (item) => item.sample_type_id === sampleType.sample_type_id
      );

      if (existingIndex === -1) {
        updatedSampleTypes.push({
          ...sampleType,
          barcode_no: newValue,
        });
      } else {
        updatedSampleTypes[existingIndex] = {
          ...updatedSampleTypes[existingIndex],
          barcode_no: newValue,
        };
      }

      return updatedSampleTypes;
    });

    setPackageInvestigationData((prev) => {
      const updatedData = prev.map((row) => {
        if (
          row.sample_type_obj?.some(
            (item) => item.sample_type_id === sampleType.sample_type_id
          )
        ) {
          return {
            ...row,
            barcode_obj: {
              ...row.barcode_obj,
              barcode_no: newValue,
            },
          };
        }
        return row;
      });

      setBarcodeDataState((prevState) => {
        const updatedState = { ...prevState };
        updatedData.forEach((row, index) => {
          updatedState[index] = {
            ...updatedState[index],
            barcode_no: row?.barcode_obj?.barcode_no,
          };
        });
        return updatedState;
      });

      return updatedData;
    });

    setIsThirdPartyBarcode(true);
  }, []);

  const columns = useMemo(
    () =>
      PACKAGE_COLUMNS_DATA(
        handleBarcodeChange,
        barcodeDataState,
        shouldIncludeBarcodeFlag
      ),
    [handleBarcodeChange, shouldIncludeBarcodeFlag]
  );

  const login = useSelector((state) => state.jwtAuthreducer);

  const ROLE = "REGISTRATION FORMAT CHANGE";

  const hasRole = login?.user?.employee_roles?.some(
    (role) => role.role_name === ROLE
  );

  return (
    <div className="container-fluid mb-3">
      {hasRole ? (
        <RegistrationFormFormat
          rowData={rowDataForEdit}
          zoneRegistrationData={getValues}
          handleDocuments={handleDocuments}
          documentInfo={documentInfo}
          setdocumentInfo={setdocumentInfo}
          appointment_id={appointment_id}
          openPackageView={openPackageView}
          isThirdPartyBarcode={isThirdPartyBarcode}
          barcodeDataState={barcodeDataState}
          setDocmentAppointmentBookingId={setDocmentAppointmentBookingId}
          packageInvestigationData={packageInvestigationData}
          handleBarcodeChange={handleBarcodeChange}
          setPackageInvestigationData={setPackageInvestigationData}
        />
      ) : (
        <RegistrationForm
          rowData={rowDataForEdit}
          zoneRegistrationData={getValues}
          handleDocuments={handleDocuments}
          documentInfo={documentInfo}
          setdocumentInfo={setdocumentInfo}
          appointment_id={appointment_id}
          openPackageView={openPackageView}
          isThirdPartyBarcode={isThirdPartyBarcode}
          barcodeDataState={barcodeDataState}
          setDocmentAppointmentBookingId={setDocmentAppointmentBookingId}
          sampleTypeData={sampleTypeData}
          barcodeData={barcodeData}
          setSampleTypeData={setSampleTypeData}
          setBarcodeData={setBarcodeData}
        />
      )}

      <Modal
        type="modal-lg"
        show={documentModal}
        onHide={() => setDocumentModal(false)}
        modalName={MODALS.ADD_MODAL}
        title={"Upload File"}
        body={
          <UploadDocument
            rowData={rowDataForEdit}
            onClose={onClose}
            setdocumentInfo={setdocumentInfo}
            setDocumentModal={setDocumentModal}
            docmentAppointmentBookingId={docmentAppointmentBookingId}
          />
        }
      />
      <Modal
        type="modal-xl"
        show={packageView}
        onHide={() => setPackageView(false)}
        modalName={MODALS.ADD_MODAL}
        title={"Package Investigation Details"}
        body={
          <Table
            data={packageInvestigationData}
            isLoading={packageInvestigationData ? false : true}
            tableColumns={columns}
            showPagination={false}
          />
        }
      />
    </div>
  );
};

export default NewRegistration;
